export const elementNotNullOrUndefined = <TResult>(element: TResult | null | undefined): element is TResult => !!element;
